// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterTwoToneSvg from "@ant-design/icons-svg/es/asn/FilterTwoTone";
import AntdIcon from '../components/AntdIcon';

var FilterTwoTone = function FilterTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterTwoToneSvg
  }));
};

FilterTwoTone.displayName = 'FilterTwoTone';
export default React.forwardRef(FilterTwoTone);